import { UserAgent } from '../userAgent';
import { PlatformService } from './PlatformService';
// import type { ShareParams } from "vue-social-sharing/types/share-params.ts";
// import {useShareLink} from "vue3-social-sharing";
import { isRunningAsPWA } from '@/scripts/assets/scripts/utils';
// import { copyToClipboard } from '@/assets/scripts/utils';

// declare global {
//     interface Window {
//         ApplicationInfo: {
//             shareType: Function;
//         };
//     }
// }
class webService implements PlatformService {
    static instance: webService;

    constructor() { }
    static get Instance() {
        if (!this.instance) {
            this.instance = new webService();
        }
        return this.instance;
    }
    getShareUrl(code?: string): string {
        return this.updateUrlParams({ code: code! });
    }

    async openUrl(url: string): Promise<boolean> {
        window.open(url, '_blank');
        return true;
    }

    //分享URL（使用vue-social-sharing或降级方案）
    async shareUrl(url: string): Promise<boolean> {
        try {
            if (navigator.share) {
                await navigator.share({ url });
                return true;
            }
            return false;
            //return this.useSocialSharing({ url });
        } catch (e) {
            return false;
        }
    }

    async shareText(text: string): Promise<boolean> {
        try {
            if (navigator.share) {
                await navigator.share({ text });
                return true;
            }
            return false;
            //return this.useSocialSharing({ title: text });
        } catch (e) {
            return false;
        }
    }

    // 4. 分享图片（H5限制较多，需转换为Blob URL）
    async shareImage(imagePath: string): Promise<boolean> {
        try {
            if (navigator.share) {
                const response = await fetch(imagePath);
                const blob = await response.blob();
                const file = new File([blob], 'image.jpg', { type: blob.type });
                await navigator.share({ files: [file] });
                return true;
            } else {
                // PC端无法直接分享图片，降级为打开图片URL
                window.open(imagePath, '_blank');
                return false;
            }
        } catch (e) {
            return false;
        }
    }

    // 5. 选择单张图片（H5实现）
    async selectSingleImage(element?: HTMLInputElement): Promise<string | null> {
        if (!element) {
            return null;
        }
        return new Promise(resolve => {
            // const element = document.createElement('input');
            // element.type = 'file';
            // element.accept = 'image/*';
            element.onchange = e => {
                const file = (e.target as HTMLInputElement).files?.[0];
                if (file) resolve(URL.createObjectURL(file));
                else resolve(null);
            };
            element.click();
        });
    }

    //选择多张图片
    async selectMultipleImages(element?: HTMLInputElement): Promise<string[]> {
        if (!element) {
            return [];
        }
        return new Promise(resolve => {
            // const element = document.createElement('input');
            // element.type = 'file';
            // element.accept = 'image/*';
            // element.multiple = true;
            element.onchange = e => {
                const files = Array.from((e.target as HTMLInputElement).files || []);
                resolve(files.map(file => URL.createObjectURL(file)));
            };
            element.click();
        });
    }

    // 使用vue3-social-sharing组件 向指定平台分享内容
    //   public useSocialSharing( params: { url?: string; title?: string ,network?: string}): boolean {
    //     if(!params.network){
    //       params.network = "facebook";
    //     }
    //     const {shareLink,getSharingLink} = useShareLink();
    //     var shareParams : ShareParams = {
    //       network: params.network,
    //       url: params.url,
    //       title: params.title,
    //     }
    //     const sharingUrl = getSharingLink(shareParams);
    //     console.log('生成的分享链接:', sharingUrl);
    //     shareLink(shareParams)

    //   return false;
    // }

    /**
     * 获取当前 URL 的查询参数
     * @returns 包含查询参数的对象
     */
    getQueryParams(url: string = window.location.href): Record<string, string> {
        const query = new URL(url).search.substring(1);
        const params: Record<string, string> = {};
        if (query) {
            const pairs = query.split('&');
            pairs.forEach(pair => {
                const [key, value] = pair.split('=');
                //过滤掉不要的参数和空参数
                if (key && key != "time" && key != "v" && (value || '').length > 0) {
                    params[key] = value || '';
                }
            });
        }
        return params;
    }
    /**
     * 构建查询字符串
     * @param params 包含查询参数的对象
     * @returns 查询字符串
     */
    buildQueryString(params: Record<string, string>): string {
        return Object.entries(params)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
    }

    /**
     * 修改或追加 URL 参数
     * @param params 要修改或追加的参数
     * @param url 输入的 URL 字符串，默认为当前页面的 URL
     * @param overwrite 是否覆盖所有现有参数，默认为 true（覆盖）
     * @returns 新的 URL 字符串
     */
    updateUrlParams(
        params: Record<string, string> = {},
        url: string = window.location.href,
        overwrite: boolean = true
    ): string {
        if (this.isRunApp()) {
            params.usource = '3';
        } else if (isRunningAsPWA()) {
            params.usource = '2';
        } else {
            params.usource = '1';
        }
        const currentParams = this.getQueryParams(url);
        const updatedParams = overwrite ? params : { ...currentParams, ...params };
        const queryString = this.buildQueryString(updatedParams);
        const newUrl = new URL(url);
        newUrl.search = queryString;
        return newUrl.toString();
    }
    shareDeepLink(type: ShareType, options: ShareData): Promise<Boolean> {
        return new Promise<Boolean>(async (resolve, reject) => {
            const encodedText = encodeURIComponent(options.text || '');
            const encodedUrl = encodeURIComponent(options.url as string);
            const encodedTitle = encodeURIComponent(options.title || '');
            let shareUrl = '';
            const isApple = UserAgent.isAppleMobile();
            switch (type) {
                case 'Facebook':
                    if (isApple) {
                        window.location.href = `fb://share/?link=${encodedUrl}`;
                        resolve(true); // 成功触发链接分享
                        return;
                    } else {
                        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
                    }
                    break;
                case 'Whatsapp':
                    shareUrl = `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}&url=${encodedUrl}`;
                    break;
                case 'Telegram':
                    // shareUrl = `tg://msg?url=${encodedUrl}&text=${encodedText}`;
                    shareUrl = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
                    break;
                case 'Twitter':
                    //shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`;
                    shareUrl = `https://x.com/intent/post?text=${encodedText} ${encodedUrl}`;
                    break;
                case 'Instagram':
                    // shareUrl = `https://www.instagram.com/share?url=${encodedUrl}&text=${encodedText}`;
                    // shareUrl = `instagram:/?quote=${encodedUrl}$url=${encodedUrl}&text=${encodedText}`;
                    shareUrl = `instagram://share?text=${encodedText}`;
                    break;
                case 'Kwai':
                    //shareUrl = `https://www.kwai.com/share?url=${encodedUrl}&desc=${encodedText}`;
                    shareUrl = `kwai:/?content=${encodedUrl}`;
                    // shareUrl = "ikwai://home";
                    break;
                case 'TikTok':
                    // shareUrl = `https://www.tiktok.com/share/url?url=${encodedUrl}&text=${encodedText}`;
                    shareUrl = `https://www.tiktok.com/?redirect_url=https://www.tiktok.com/?text=${encodedUrl}&enter_method=mandatory`;
                    break;
                case 'Youtube':
                    //shareUrl = `https://www.youtube.com/share?url=${encodedUrl}&text=${encodedText}`;
                    // shareUrl = `youtube:/?text=${encodedText} ${encodedUrl}&url=${encodedUrl}`;
                    const schemes = {
                        home: {
                            android: 'vnd.youtube://',
                            ios: 'youtube://',
                            web: 'https://www.youtube.com',
                        },
                        // share: {
                        //     android: `intent://send?text=${encodedText}#Intent;` +
                        //         `package=com.google.android.youtube;` +
                        //         `action=android.intent.action.SEND;` +
                        //         `type=text/plain;` +
                        //         `S.android.intent.extra.TEXT=${encodedText} ${encodedUrl};` +
                        //         `end`,
                        //     ios: `youtube://share?text=${encodedText}&url=${encodedUrl}`,
                        //     web: `https://www.youtube.com/share?text=${encodedText}&url=${encodedUrl}`
                        // },
                        // video: {
                        //     android: `vnd.youtube://watch?v=${videoId}`,
                        //     ios: `youtube://watch?v=${videoId}`,
                        //     web: `https://youtu.be/${videoId}`
                        // }
                    };

                    // 根据目标选择方案
                    let urls = schemes.home;
                    // 尝试唤起 App
                    if (navigator.userAgent.match(/Android/i)) {
                        shareUrl = urls.android;
                    } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                        shareUrl = urls.ios;
                    } else {
                        shareUrl = urls.web;
                    }
                    break;
                case 'Mais':
                case 'More':
                    let isShare = false;
                    try {
                        if (navigator && navigator.share && navigator.canShare?.(options)) {
                            await navigator.share(options);
                            isShare = true;
                        }
                    } catch (e) {
                    } finally {
                        if (!isShare) {
                            if (UserAgent.isAppleMobile()) {
                                if (!UserAgent.isIosSafari()) {
                                    UserAgent.openSafari(options.url!);
                                }
                            } else {
                                UserAgent.openAndroidDefaultBrowser(options.url!);
                            }
                            this.copyToClipboard(`${options.url}\n\n${options.text}`);
                        }
                    }
                default:
                    this.copyToClipboard(`${options.url}\n\n${options.text}`);
                    resolve(false);
                    return;
            }

            if (shareUrl && shareUrl.length > 0) {
                this.copyToClipboard(`${options.url}\n\n${options.text}`);
                this.openUrl(shareUrl);
                resolve(true); // 成功触发链接分享
                return;
            } else {
                reject('No share URL available');
            }
        });
    }

    /**
     * 调用手机分享功能
     * @param evnet 
     * @param data 
     */
    appShare = (evnet: string, data: any): boolean => {
        if (typeof window.jsBridge?.shareType === 'function') {
            window.jsBridge?.shareType?.(evnet, data);
            return true;
        }
        return false;
    }

    /**
     *  调用手机跳转 浏览器 url
     * @param url 
     */
    appOpenURL = (url: string): boolean => {
        if (typeof window.jsBridge?.openURL === 'function') {
            window.jsBridge?.openURL?.(url);
            return true;
        }
        return false;
    }

    /**
    *  调用手机跳转 浏览器 url
    * @param evnet 
    * InitiateCheckout:创建订单
    * Purchase:首充
    * SubmitApplication:登录
    * CompleteRegistration:注册
    * StartTrial:开始游戏
    * @param data  json数据
    */
    appPostMessage = (evnet: string, data: any): boolean => {
        if (typeof window.jsBridge?.postMessage === 'function') {
            console.log(`发送事件(postMessage): ${evnet}:`, data);
            window.jsBridge?.postMessage?.(evnet, data);
            return true;
        }
        return false;
    }
    /**
     *  调用App清理缓存
     * @param url 
     */
    appClearCache = (): boolean => {
        if (typeof window.jsBridge?.clearCache === 'function') {
            window.jsBridge?.clearCache?.();
            return true;
        }
        return false;
    };

    /**
    * 
    *  重启APP
    *  //上架马甲包没有这个方法，如果不存在调用 jsBridge
    * @param url 
    */
    appRestartApp = (): boolean => {
        if (typeof window.jsBridge?.restartApp === 'function') {
            window.jsBridge?.restartApp?.();
            return true;
        }
        return this.appExtAPP();
    };

    /**
    *  调用App退出
    * @param url 
    */
    appExtAPP = (): boolean => {
        if (typeof window.jsBridge?.extAPP === 'function') {
            window.jsBridge?.extAPP?.();
            return true;
        }
        return false;
    };

    /**
    *  调用App版本号
    * @param url 
    */
    appVersionCode = (): string => window.jsBridge?.getVersionCode?.() || '';

    appInvitationCode = (): string => window.jsBridge?.getInvitationCode?.() || '';

    /**
    *  调用App包名
    * @param url 
    */
    appPackage = (): string => window.jsBridge?.getPackage?.() || import.meta.env.VITE_PACKAGE || '';

    /**
     * 是否 app 运行环境
     * @returns 
     */
    isRunApp = (): boolean => import.meta.env.VITE_PLATFORM === 'android' || 'jsBridge' in window;


    shareType(type: ShareType, options: ShareData): Promise<Boolean> {
        return new Promise<Boolean>(async (resolve, reject) => {
            if (this.isRunApp()) {
                try {
                    const typeString = String(type);
                    this.appShare(String(type), JSON.stringify(options))
                    console.log('Android 分享', { type: typeString, options });
                    return true;
                } catch (error) {

                }
            }
            // 如果支持 Web Share 且平台可以用
            this.shareDeepLink(type, options)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    //alert(err);
                    reject(err);
                });
        });
    }

    copyToClipboard(text: string) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.warn('Clipboard copy failed:', err);
        }
        document.body.removeChild(textarea);
    }
}

export type ShareType =
    | 'More'
    | 'Mais'
    | 'Facebook'
    | 'Whatsapp'
    | 'Telegram'
    | 'Instagram'
    | 'Kwai'
    | 'Twitter'
    | 'TikTok'
    | 'Youtube';
export let WebService = webService.Instance;
